// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".a-notice[data-v-90380070] {\n  margin-bottom: 18px;\n}\n.el-notification[data-v-90380070] {\n  z-index: 5000 !important;\n}", ""]);
// Exports
module.exports = exports;
